/** Ladezustände sind Skeletons, keine Spinner — sie zeigen, was gleich kommt. */
export function Skeleton({ breiten }: { breiten: string[] }) {
  return (
    <div aria-hidden="true" className="space-y-3">
      {breiten.map((breite, index) => (
        <div
          key={index}
          className="bg-on-surface-muted/20 animate-atmen h-4 rounded"
          style={{ width: breite, animationDelay: `${String(index * 120)}ms` }}
        />
      ))}
    </div>
  )
}
